import { FlipBook } from './assets/_flip-book'
// import { lerp } from './assets/_utils'
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Scrollbar, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, Scrollbar]) // Swiper宣言

if (document.getElementById('page-top')) {
  setAbout()
  setBusiness()
  setCompany()
}

function setAbout() {
  const content = document.querySelector('.topAbout__content')
  const container = document.querySelector('.topAbout__container')
  const inner = document.querySelector('.topAbout__inner')

  const adjustScroll = () => {
    const { clientWidth, clientHeight, scrollTop } = document.documentElement

    const contentTop = content.getBoundingClientRect().top + scrollTop
    const containerTop = container.getBoundingClientRect().top + scrollTop

    const ratio = ((containerTop - contentTop) / (content.clientHeight - clientHeight)).clamp(0, 1)

    const diff = (inner.clientHeight - clientHeight) * -ratio
    inner.style.transform = `translate3d(0, ${diff}px, 0)`
  }

  window.addEventListener('resize', adjustScroll)
  window.addEventListener('scroll', adjustScroll)
  adjustScroll()
}

function setAboutFlip() {
  let pcFlip1, pcFlip2

  // ブレイクポイントを設定
  const mediaQuery = window.matchMedia('(min-width: 768px)')

  function checkWindow(windowSize) {
    // ウィンドウサイズが768px以上か
    if (windowSize.matches) {
      // 768px以上の時（PCの処理）
      // console.log('PC')
    } else {
      // 上記以外の時（SPの処理）
      // console.log('SP')
    }

    /**
     * 通信基地局モデル（PC/SP共通）
     */
    if (!pcFlip1) {
      pcFlip1 = getAboutFlip1()
    }

    /**
     * アンテナモデル（PC/SP共通）
     */
    if (!pcFlip2) {
      pcFlip2 = getAboutFlip2()
    }
  }

  // ロード時に判定
  checkWindow(mediaQuery)
  // ブレイクポイントが切り替わったら判定
  mediaQuery.addEventListener('change', checkWindow)
}

function getAboutFlip1() {
  const flip1 = document.getElementById('aboutFlip1')
  if (flip1) {
    const area = document.querySelector('.topAbout__wrap--before')
    const image_name = tUrl + 'img/top/about-flip1/cut01_comp_'
    const image_count = 839
    const image_ext = '.png'
    const option = {
      offsetBottom: 1,
      zeroPadding: '000',
      fade: 'out',
      fadeOffsetTop: 1.5,
      fadeOffsetBottom: 0.5,
    }

    return new FlipBook(flip1, area, image_name, image_count, image_ext, option)
  }

  return null
}

function getAboutFlip2() {
  const flip2 = document.getElementById('aboutFlip2')

  if (flip2) {
    const area = document.querySelector('.topAbout__wrap--after')
    const image_name = tUrl + 'img/top/about-flip2/'
    const image_count = 4
    const image_ext = '.jpg'
    const option = {
      offsetTop: 1,
      crossFade: true,
    }

    return new FlipBook(flip2, area, image_name, image_count, image_ext, option)
  }

  return null
}

function setBusiness() {
  const swiper = new Swiper('.js-business-swiper', {
    loop: false,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 24,
    centeredSlides: false,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   hide: false,
    //   draggable: true,
    // },

    breakpoints: {
      769: {
        slidesPerGroup: 1,
        spaceBetween: 48,
      },
    },
  })
}

function setCompany() {
  const swiper = new Swiper('.js-company-swiper', {
    loop: false,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 24,
    centeredSlides: false,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   hide: false,
    //   draggable: true,
    // },

    breakpoints: {
      769: {
        slidesPerGroup: 1,
        spaceBetween: 48,
      },
    },
  })
}
